<main id="technical-dashboard" class="technical-dashboard px-4">
  <h1>{{ dashboardTitle }}</h1>
  <p class="mb-4" i18n="@@TechnicalDashboardIntro">Ladestationen und aktive Ladevorgänge (ohne personenbezogene Daten).</p>

  <app-technical-charging-points></app-technical-charging-points>

  <div class="card running-transactions-card mb-4">
    <div class="card-header card-title">
      <h5 class="m-0 p-0" i18n="@@TechnicalDashboardRunningTransactions">Aktive Ladevorgänge</h5>
    </div>
    <div class="card-body transactions-grid" *ngIf="!loadingTransactions && runningTransactions.length > 0">
      <ng-container *ngFor="let tx of runningTransactions; trackBy: trackByTransactionId">
        <div class="box">
          <div class="p-3">
            <h6>
              <span class="float-start">
                {{ tx.chargingStationName || '–' }} {{ getChargingPointLabel(tx) }}
              </span>
              <span class="status-icon float-end">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-zap">
                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                </svg>
              </span>
            </h6>
            <h5 class="card-title text-muted small" i18n="@@TechnicalDashboardNoUserData">Ladevorgang (ohne Nutzerdaten)</h5>
            <div class="d-flex flex-wrap gap-2 align-items-center mt-2">
              <span class="badge bg-secondary">{{ tx.meterAmount ?? tx.meterStart }} kWh</span>
              <span class="text-muted small">{{ tx.startTimestamp | date:'short' }}</span>
            </div>
          </div>
          <small class="text-muted float-start d-flex py-2 px-3 mt-0 running-duration" i18n="@@TransactionDurationText">
            <span>{{ tx.duration ?? '–' }}</span>
          </small>
        </div>
      </ng-container>
    </div>
    <div class="card-body" *ngIf="loadingTransactions">
      <p class="text-muted mb-0" i18n="@@Loading">Laden…</p>
    </div>
    <div class="card-body" *ngIf="!loadingTransactions && runningTransactions.length === 0">
      <p class="text-muted mb-0" i18n="@@NoRunningTransactions">Keine aktiven Ladevorgänge.</p>
    </div>
  </div>

</main>
